import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'

export const usePainterAdditionalWorkStyles = makeStyles<Theme>((theme) => ({
  additionalWorkSection: { marginTop: theme.spacing(1) },
  additionalWorkHeader: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1.25)
  },
  additionalWorkHeading: {
    ...theme.typography.h4,
    fontWeight: theme.typography.fontWeightMedium,
    marginTop: theme.spacing(3)
  },
  addLink: {
    padding: 0,
    fontWeight: theme.typography.fontWeightMedium,
    marginRight: theme.spacing(-1.25)
  },
  summaryRow: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.borderRadius.md,
    border: `1px solid ${theme.palette.background.default}`,
    marginBottom: theme.spacing(1.25),
    cursor: 'pointer',
    overflow: 'hidden'
  },
  summaryRowHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.25, 1.5),
    height: '40px'
  },
  summaryRowCollapsed: {
    backgroundColor: `${theme.palette.common.white} !important`,
    border: `1px solid ${theme.palette.divider} !important`
  },
  summaryRowExpanded: { border: '1px solid #E5E7EB', borderRadius: '4px 4px 0 0 !important' },
  summaryRowLabel: { ...theme.typography.body1, color: theme.palette.text.primary },
  summaryRowValue: { display: 'flex', alignItems: 'center', gap: theme.spacing(1) },
  summaryRowValueText: {
    ...theme.typography.body1,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary
  },
  summaryRowIcon: { fontSize: 16, color: theme.paintscout.palette.brand.Neutral.P60 },
  awItemContent: {
    backgroundColor: theme.palette.common.white,
    border: '1px solid #E5E7EB',
    borderTop: 'none',
    borderRadius: '0 0 4px 4px',
    marginTop: -10,
    marginBottom: theme.spacing(1.25),
    overflow: 'hidden'
  },
  acceptSignRow: {
    backgroundColor: theme.palette.common.white,
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 0.75)
  },
  acceptSignBtn: {
    width: '100%',
    minHeight: 40,
    fontSize: theme.typography.pxToRem(12),
    backgroundColor: `${theme.palette.success.main} !important`
  },
  approvedRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.25),
    padding: theme.spacing(1.25, 1.5),
    backgroundColor: theme.paintscout.palette.secondary[140].C95,
    borderTop: `1px solid ${theme.palette.divider}`
  },
  approvedIcon: { fontSize: 16, color: theme.palette.success.dark },
  approvedText: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.success.dark
  },
  approvedDate: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.success.dark,
    marginLeft: 'auto',
    whiteSpace: 'nowrap'
  },
  awDescription: {
    padding: theme.spacing(2, 1.5),
    ...theme.typography.body2,
    color: theme.paintscout.palette.brand.Neutral.P60,
    '& p': {
      margin: '0px'
    }
  },
  awActions: {
    borderTop: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5)
  },
  awActionBtn: {
    minHeight: 30,
    color: theme.paintscout.palette.brand.Neutral.P40,
    borderColor: '#DADEE8',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
    '&:hover': {
      color: theme.paintscout.palette.brand.Neutral.P40,
      borderColor: '#DADEE8',
      backgroundColor: theme.paintscout.palette.brand.Neutral.P94
    }
  },
  awActionBtnGroup: { display: 'flex', gap: theme.spacing(0.5), flexWrap: 'wrap', marginLeft: 'auto' },
  awViewMediaRow: {
    borderTop: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(1, 1.5),
    backgroundColor: theme.palette.background.default
  },
  awViewMediaBtn: { width: '100%' }
}))
